import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Cash Is King",
    body: "Liquidity is freedom. Before growth, before returns, you build a foundation that lets you sleep at night and act when others panic.",
  },
  {
    n: "02",
    title: "Cashflow Is Kingdom",
    body: "A one-time win feels good. A cashflow system changes your life. We architect predictable, repeatable income — not lucky bets.",
  },
  {
    n: "03",
    title: "Discipline Beats Prediction",
    body: "Nobody times the market twice. We automate decisions in advance so emotion never gets a vote. Boring, repeatable, and it works.",
  },
  {
    n: "04",
    title: "Build Your Kingdom",
    body: "Brick by brick, SIP by SIP, allocation by allocation. Wealth is designed on purpose — this is your blueprint.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative z-10 py-24 md:py-32 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-16">
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-28">
              <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary mb-4">/ The Manifesto</p>
              <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl">
                Four laws of the kingdom
              </h2>
            </div>
          </div>

          <div className="lg:col-span-3">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                data-testid={`manifesto-chapter-${c.n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className={`grid grid-cols-1 sm:grid-cols-6 gap-4 sm:gap-8 py-10 ${
                  i !== chapters.length - 1 ? "border-b border-border" : ""
                }`}
              >
                <div className="sm:col-span-1">
                  <span className="font-display font-black text-5xl sm:text-6xl text-primary leading-none">{c.n}</span>
                </div>
                <div className="sm:col-span-5">
                  <h3 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-4xl mb-3">{c.title}</h3>
                  <p className="text-muted-foreground text-base sm:text-lg leading-relaxed max-w-2xl">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
